/**
 * How a voucher transport leg travels. The stored enum value, printed through
 * the client's own label map — same convention as `VoucherVendorDto.kind`.
 */
export const TRANSPORT_LEG_MODES = ['FLIGHT', 'TRAIN', 'BUS', 'CAR', 'FERRY', 'OTHER'];
/**
 * The most transport legs one voucher may carry.
 *
 * Shared so the editor can stop offering "add leg" at the same number the
 * server enforces. Enforced on the server UNDER A VOUCHER-ROW LOCK against the
 * resulting total, not just per request — see `VouchersService.update`.
 */
export const MAX_VOUCHER_TRANSPORT_LEGS = 10;
/** Same reasoning as `MAX_VOUCHER_TRANSPORT_LEGS`, for hotel-detail rows. */
export const MAX_VOUCHER_HOTEL_DETAILS = 10;
//# sourceMappingURL=voucher.js.map